var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM32.8994 12.529C33.478 11.9505 33.478 11.0125 32.8994 10.4339C32.3209 9.85536 31.3828 9.85536 30.8043 10.4339L15.5556 25.6826L9.19571 19.3228C8.61716 18.7442 7.67914 18.7442 7.10058 19.3228C6.52203 19.9014 6.52203 20.8394 7.10058 21.4179L14.508 28.8253C15.0865 29.4039 16.0246 29.4039 16.6031 28.8253L32.8994 12.529Z",
    fill: "#477237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOrder);
export default __webpack_public_path__ + "static/media/successOrder.39f687b833ada9a53189251d8236df4c.svg";
export { ForwardRef as ReactComponent };